var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00342 5.99013C4.79342 5.99013 4.60342 5.91022 4.46342 5.7504L0.213424 1.26537C-0.0765762 0.95571 -0.0665762 0.48623 0.243424 0.20654C0.543424 -0.0831387 1.02342 -0.0631609 1.30342 0.236507L5.00342 4.15217L8.70342 0.236507C8.98342 -0.0631609 9.46342 -0.0831387 9.76342 0.20654C10.0634 0.48623 10.0834 0.965699 9.79342 1.26537L5.54342 5.76039C5.40342 5.91022 5.20342 6.00012 5.00342 6.00012V5.99013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.c0d1a8685c2d84555aa1da63e2fec338.svg";
export { ForwardRef as ReactComponent };